type FeatureLinkCardProps = {
  title: string
  description: string
  image: string
  linkUrl?: string
}

export const toolLinkCardsData: FeatureLinkCardProps[] = [
  {
    title: 'Data security',
    description: 'Prevent data leakage by enforcing permissions.',
    image: '/images/pages/home/tool-link-cards/data-security.webp',
    linkUrl:
      'https://docs.omni.co/docs/modeling/topics/parameters#access_filters/',
  },
  {
    title: 'Branch mode',
    description: 'Tune AI context without impacting what’s live.',
    image: '/images/pages/home/tool-link-cards/branch-mode.webp',
    linkUrl:
      'https://docs.omni.co/docs/finding-content/drafting-publishing/branch-mode/',
  },
  {
    title: 'Git & version control',
    description: 'Manage changes without breaking things downstream.',
    image: '/images/pages/home/tool-link-cards/git-version-control.webp',
    linkUrl: 'https://docs.omni.co/docs/integrations/git/setup/',
  },
]
